<template>
  <div class="container">
    <div class="game-container">
      <!-- Info -->
      <InfoBlock />

      <!-- Scoreboard -->
      <ScoreBoard :players="players || {}" />

      <!-- Chatbox -->
      <ChatBox :roomId="roomId" :userName="userName" />

      <!-- Game Area -->
      <GameArea
        :playerId="playerId"
        :roomId="roomId"
        :userName="userName"
        :maxPoints="maxPoints"
        @updatePlayers="updatePlayers"
      />
    </div>
  </div>
</template>

<script>
import InfoBlock from '@/components/InfoBlock.vue'
import storage from '@/utility/storage.js'
import scoreboard from '@/components/scoreboard.vue'
import chatbox from '@/components/chatbox.vue'
import GameArea from '@/components/GameArea.vue'

export default {
  components: {
    InfoBlock: InfoBlock,
    ScoreBoard: scoreboard,
    ChatBox: chatbox,
    GameArea: GameArea,
  },
  data() {
    return {
      playerId: storage.get('playerId'),
      userName: storage.get('userName'),
      roomId: storage.get('gameId'),
      maxPoints: this.$route.query.maxPoints,
      players: {},
    }
  },
  methods: {
    updatePlayers(newPlayers) {
      this.players = newPlayers
    },
  },
}
</script>